import { differentials } from "@/mocks/serra";

function StepCard({ step }: { step: (typeof differentials)[number] }) {
  return (
    <div className="w-[320px] sm:w-[380px] flex-shrink-0 rounded-2xl border border-white/10 bg-bg/60 backdrop-blur-sm p-10">
      <span className="font-mono-tech text-6xl text-white/10">{step.number}</span>
      <h3 className="text-2xl font-semibold text-white mt-4 mb-3">{step.title}</h3>
      <p className="text-white/55 leading-relaxed">{step.desc}</p>
    </div>
  );
}

export default function Differentials() {
  return (
    <section id="diferenciais" className="relative bg-blue/10 overflow-hidden py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-12">
        <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase mb-4 block">
          Diferenciais
        </span>
        <h2 className="text-white text-3xl lg:text-5xl font-bold max-w-2xl">
          Um processo pensado para gerar resultado, não só entrega
        </h2>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-16 lg:w-40 bg-gradient-to-r from-blue/30 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-16 lg:w-40 bg-gradient-to-l from-blue/30 to-transparent z-10 pointer-events-none"></div>

        <div className="flex gap-6 w-max px-6 lg:px-10 animate-marquee [animation-duration:38s] hover:[animation-play-state:paused]">
          {[...differentials, ...differentials].map((step, i) => (
            <StepCard step={step} key={`${step.number}-${i}`} />
          ))}
        </div>
      </div>
    </section>
  );
}
